module.exports = __webpack_public_path__ + "static/media/banner.f8bea305.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.jpg
// module id = 2088
// module chunks = 7